export default __webpack_public_path__ + "static/media/13.f80411a2.jpg";